module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("e1JDP"))).then(() => parcelRequire('hEqeo'));